module.exports = __webpack_public_path__ + "static/media/zera_move_head.25d40a39.png";